import { Box } from "@mui/material";
import { FEED_RIGHT_PANEL_WIDTH } from "app/appConstants";
import { useWindowSize } from "hooks/useWindowSize";
import { INSIDE_LAYOUT_CONTENT_CONTAINER_ID } from "layouts/common/inside/MprcLayoutInside";
import { JSX, useEffect, useRef } from "react";
import { OutsideRightPanel } from "views/knowledge/publication/pages/components/OutsideRightPanel";
import { ENROLLMENT_VIEW_BAR_ID } from "views/lms/student/EnrollmentView/Shared/EnrollmentViewBar";
import { useEnrollmentViewContext } from "..";

////////////////////////////////////////////////////////////////////////////////

interface PageContentBoxProps {
    id?: string;
    content?: JSX.Element;
    rightPanel?: React.ReactElement;
}

/////////////////////////////////////////////////////////////////////////////////////

const RIGHT_PANEL_CONTAINER_ID = "enrollmentViewRightPanelContainer";

export const EnrollmentViewContainer = ({ id, content, rightPanel }: PageContentBoxProps) => {

    const { height: windowHeight } = useWindowSize();

    const { openRightPanel, setOpenRightPanel } = useEnrollmentViewContext();

    let feedRef = useRef<HTMLDivElement>(undefined!);

    var barHeight = useRef(0);

    useEffect(() => {
        const barContainer = document.getElementById(ENROLLMENT_VIEW_BAR_ID);
        if (barContainer) {
            const enrollmentViewBarCs = getComputedStyle(barContainer);
            barHeight.current = parseInt(enrollmentViewBarCs.height);
        }
    }, []);

    /** Ajusta a Altura Inicial da Área Lateral Direita */
    useEffect(() => {
        const container = document.getElementById(INSIDE_LAYOUT_CONTENT_CONTAINER_ID);
        if (container) {
            const cs = getComputedStyle(container);
            const containerPaddingY = parseFloat(cs.paddingTop);
            const offset = feedRef.current.offsetTop - container.offsetTop - containerPaddingY;

            if (offset > 0) feedRef.current.style.minHeight = `calc(100% - ${offset}px)`;
            else feedRef.current.style.minHeight = "100%";

            const rightPanel = document.getElementById(RIGHT_PANEL_CONTAINER_ID);
            if (rightPanel) rightPanel.style.height = (parseInt(cs.height) - barHeight.current) + "px";
        }
    }, [feedRef.current, barHeight.current, windowHeight]);

    return (
        <Box
            id={id}
            ref={feedRef}
            sx={(theme) => ({
                display: "flex",
                gap: 2,
                maxWidth: theme.breakpoints.values["xl"],
                margin: "0 auto"
            })}
        >
            <Box sx={{ flex: 1, minWidth: 0 }}>
                {content}
            </Box>
            <Box id={RIGHT_PANEL_CONTAINER_ID}
                sx={(theme) => (
                    {
                        width: FEED_RIGHT_PANEL_WIDTH,
                        padding: theme.spacing(1),
                        paddingTop: 0,
                        display: { xs: "none", md: "block" },
                        position: "sticky",
                        alignSelf: "start",
                        top: `${barHeight.current}px`,
                        overflowY: "auto",
                        "::-webkit-scrollbar": {
                            width: 8,
                            height: 8,
                        },
                        "::-webkit-scrollbar-track": {
                            backgroundColor: "transparent",
                        },
                        "::-webkit-scrollbar-thumb": {
                            backgroundColor: "transparent",
                            borderRadius: "50px",
                            border: "3px solid transparent"
                        },
                        "&:hover": {
                            "::-webkit-scrollbar-thumb": {
                                backgroundColor: "grey",
                                border: "3px solid grey"
                            },
                            "::-webkit-scrollbar-track": {
                                backgroundColor: "lightgray",
                            }
                        }
                    })
                }
            >
                {rightPanel}
            </Box>
            {
                openRightPanel &&
                <OutsideRightPanel
                    onClose={() => setOpenRightPanel(false)}
                    content={<>{rightPanel}</>}
                />
            }
        </Box>
    );
};
